import { Card, Tag as AntdTag } from 'antd';
import { FormattedMessage } from 'react-intl';

import Icon from '../Icon/Icon';
import Tag from '../../components/Tag/Tag';

import { useIntlWrapperContext } from '../../Helpers/IntlWrapperProvider';

import { ProfileCardProps } from './ProfileCard.model';

import styles from './ProfileCard.module.scss';

const ProfileCard = ({
	actions,
	children,
	customCover,
	data,
	fitContainer,
	interactiveImage,
	hoverable,
	onClick,
	showData
}: ProfileCardProps) => {
	const { i18nCountries } = useIntlWrapperContext();
	const {
		currentPosition,
		education,
		imageId,
		languages,
		location,
		pronouns,
		name,
		researchAreas,
		userType,
		workExperience,
	} = data;

	const getTagColorByRole = (role: string) => {
		switch (role) {
			case 'Mentee': return 'grey';
			case 'Mentor': return 'blue';
			case 'Admin': return 'red';
		}
	}

	const renderChips = (chips: string[], category?: string) => {
		return chips.map((field: string, index: number) => (<AntdTag
			key={`${field}${index}`}
			style={{
				border: 'none',
				textTransform: 'uppercase'
			}}>{category ? <FormattedMessage id={`${category}.${field}`} /> : field}</AntdTag>))
	}

	return (
		<Card
			actions={actions}
			bodyStyle={!showData ? { padding: 0 } : {}}
			className={`${styles.card} ${hoverable ? styles.hoverable : ''} ${fitContainer ? styles.fitContainer : ''}`}
			cover={
				customCover ? customCover :
					<div className={`${styles.imageWrapper} ${interactiveImage ? styles.interactive : ''} ${imageId ? styles.whiteBg : ''}`} onClick={onClick}>
					{imageId ?
						<img alt="" src={imageId} /> :
						<>
							<Icon name="image" height="60px" width="60px" color="white" />
							<span><FormattedMessage id="buttons.addImage" /></span>
						</>
					}
				</div>
			}
			hoverable={hoverable}
		>
			{showData &&
				<div className={styles.detailsContainer}>
					<span className={styles.title} onClick={onClick}>{name}</span>
					{(userType || researchAreas) &&
						<div className={styles.tags}>
							{userType && <Tag color={getTagColorByRole(userType)}>{userType}</Tag>}<br />
							{researchAreas && renderChips(researchAreas, 'researchAreas')}
						</div>
					}
					{pronouns &&
						<div className={styles.details}>
							<div className={styles.iconWrapper}>
								<Icon name="user-gender" width="18px" />
							</div>
							<span><FormattedMessage id={`pronouns.${pronouns}`} /></span>
						</div>
					}
					{currentPosition &&
						<div className={styles.details}>
							<div className={styles.iconWrapper}>
								<Icon name="diploma" type="solid" width="18px" />
							</div>
							<span><FormattedMessage id={`currentPosition.${currentPosition}`} /></span>
						</div>
					}
					{workExperience && workExperience[0] &&
						<div className={styles.details}>
							<div className={styles.iconWrapper}>
								<Icon name="briefcase" type="solid" width="20px" />
							</div>
							<span>{workExperience[0]}</span>
						</div>
					}
					{education && education[0] &&
						<div className={styles.details}>
							<div className={styles.iconWrapper}>
								<Icon name="graduation-cap" type="solid" width="20px" />
							</div>
							<span>{education[0]}</span>
						</div>
					}
					{location &&
						<div className={styles.details}>
							<div className={styles.iconWrapper}>
								<Icon name="map-marker" type="solid" width="12px" />
							</div>
							<span>{i18nCountries[location]}</span>
						</div>
					}
					{languages &&
						<div className={styles.details}>
							<div className={styles.iconWrapper}>
								<Icon name="globe" width="16px" />
							</div>
							<div className={styles.tags}>
								{renderChips(languages)}
							</div>

						</div>
					}
				</div>
			}
			{children}
		</Card>
	);
}

export default ProfileCard;